import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, DownloadIcon, LockIcon, HeadphonesIcon, CreditCardIcon } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: ShieldIcon,
    text: 'Pago seguro'
  }, {
    icon: ShieldIcon,
    text: 'Garantía'
  }, {
    icon: DownloadIcon,
    text: 'Descarga inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte'
  }];
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-12 px-4 bg-card/20" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-8" data-id="element-170">
          {badges.map((badge, index) => <div key={index} className="flex flex-col items-center gap-2 text-center" data-id="element-171">
              <badge.icon className="w-8 h-8 text-primary" data-id="element-172" />
              <p className="text-sm font-semibold" data-id="element-173">{badge.text}</p>
            </div>)}
        </div>

        <div className="flex justify-center items-center gap-4 flex-wrap" data-id="element-174">
          <p className="text-sm text-gray-400" data-id="element-175">Aceptamos:</p>
          <div className="flex gap-3" data-id="element-176">
            <div className="bg-white text-dark px-3 py-1 rounded font-bold text-sm" data-id="element-177">
              VISA
            </div>
            <div className="bg-white text-dark px-3 py-1 rounded font-bold text-sm" data-id="element-178">
              Mastercard
            </div>
            <div className="bg-white text-dark px-3 py-1 rounded font-bold text-sm" data-id="element-179">
              AMEX
            </div>
          </div>
        </div>
      </div>
    </motion.section>;
}